<template>
  <div class="mt-1">
    <div class="row row-cols-2 row-cols-md-3 row-cols-lg-6 g-3">
      <div
          v-for="(image, index) in gallery"
          :key="index"
          class="col"
      >
        <div
            class="position-relative gallery-item"
            style="padding-bottom: 100%;"
            @click="$emit('select-image',  image)"
        >
          <img
              :src="image"
              :alt="'Generated image ' + (index + 1)"
              class="position-absolute top-0 start-0 w-100 h-100 rounded"
              style="object-fit: cover; cursor: pointer;"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {GALLERY_ENDPOINT} from "@/services/endpoints"

export default {
  name: 'ImageGallery',

  props: {
    gallery: {
      type: Array,
      required: true
    }
  },

  data: function () {
    return {
      GALLERY_ENDPOINT
    }
  }
}
</script>

<style scoped>
.gallery-item {
  transition: opacity 0.2s ease-in-out;
}

.gallery-item:hover {
  opacity: 0.75;
}
</style>